import { Observable, from } from 'rxjs';

export function fromPromiseToObservable(promise: Promise<any>): Observable<any> {
  return from(promise as Promise<any>);
}
